var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('data-fetcher',{attrs:{"fetch-data":_vm.fetch,"hide-loading":""}},[(_vm.currentTeam && !_vm.isLoading)?_c('router-view'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }